import {StatusCallModel} from '../../model/status-calls/status-call.model';
import {Searchable} from '../../state/searchable-state';
import axios from '../axios';

export namespace StatusCallController {
  export type QueryStatusCallsRes = {
    total: number
    available: any
    items: StatusCallModel[]
  }

  export type CreateStatusCallReq = {
    organizationId: string
    scheduledAt: string
    durationMinutes: number
    title?: string | null
    notes?: string | null
    meetingLink?: string | null
    participantEmails?: string[]
  }

  export type CreateStatusCallRes = {
    id: string
  }

  export type UpdateDetailsReq = {
    title?: string | null
    notes?: string | null
    meetingLink?: string | null
    participantEmails?: string[]
  }

  export type RescheduleReq = {
    scheduledAt: string
    durationMinutes: number
  }

  export const getStatusCallsCalendar = async (from: string, to: string) => {
    const fromDt = from.includes('T') ? from : `${from}T00:00:00`
    const toDt = to.includes('T') ? to : `${to}T23:59:59`
    return (await axios.get<StatusCallModel[]>(
      `/internal/status-calls/calls?from=${encodeURIComponent(fromDt)}&to=${encodeURIComponent(toDt)}`)).data
  }

  export const queryStatusCalls = async (searchable: Searchable) =>
    (await axios.put<QueryStatusCallsRes>(`/internal/status-calls/calls`, searchable)).data

  export const createStatusCall = async (request: CreateStatusCallReq) =>
    (await axios.post<CreateStatusCallRes>(`/internal/status-calls/calls`, request)).data

  export const updateStatusCallDetails = async (callId: string, version: number, request: UpdateDetailsReq) =>
    (await axios.put(`/internal/status-calls/calls/${callId}/details?version=${version}`, request))

  export const rescheduleStatusCall = async (callId: string, version: number, request: RescheduleReq) =>
    (await axios.put(`/internal/status-calls/calls/${callId}/reschedule?version=${version}`, request))

  export const cancelStatusCall = async (callId: string, version: number) =>
    (await axios.put(`/internal/status-calls/calls/${callId}/cancel?version=${version}`))

  export const completeStatusCall = async (callId: string, version: number) =>
    (await axios.put(`/internal/status-calls/calls/${callId}/complete?version=${version}`))
}
